module.exports = __webpack_public_path__ + "84c1cafa55fdbc2bffc3d34c3797a5d9.svg";